var titledElm;
const tipElm = document.createElement('div')
tipElm.classList.add('tooltip')

document.body.append(tipElm)

function overListener(e){
  var newTitledElm = (e.target as HTMLElement).closest('[titleHTML]')
  if(newTitledElm===titledElm) return;

  titledElm = newTitledElm
  if(titledElm){
    var 
      rect = titledElm.getBoundingClientRect(),
      bodyRect = document.body.getBoundingClientRect(),
      isLeft = rect.left < bodyRect.right/2,
      isTop = rect.top < bodyRect.bottom/2;
    
    tipElm.classList.add('open')
    if(isLeft){
      tipElm.style.left=rect.left+'px'
      tipElm.style.right = "unset"
    }else{
      tipElm.style.left = "unset"
      tipElm.style.right=(bodyRect.right-rect.right)+'px'
    }
    if(isTop){
      tipElm.style.top=rect.bottom+'px'
      tipElm.style.bottom = "unset"
    
    }else{
      tipElm.style.top = "unset"
      tipElm.style.bottom= (bodyRect.bottom-rect.top)+'px'
    }
    
    tipElm.innerHTML = titledElm.getAttribute('titleHTML')
    
  }else{
    tipElm.classList.remove('open')
  }
}

// event handlers
document.addEventListener('mouseover',overListener)
document.addEventListener('touchstart',()=>{
  document.removeEventListener('mouseover',overListener)
},{once:true})
